<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="wrapper">
  <div *ngIf="!submitted">
    <div class="dialog-title">Reactivate Community Access</div>
    <p>To regain access, tell us a little bit about why you're using HUNTER.</p>
    <form (ngSubmit)="onReactivate()">
      <div [formGroup]="checkboxGroup">
        <div class="reason" *ngFor="let item of reactivationReasons">
          <kendo-checkbox
            #checkedState
            [formControlName]="item"
          ></kendo-checkbox>
          <kendo-label
            class="k-checkbox-label"
            [for]="checkedState"
            text="{{ item }}"
          ></kendo-label>
        </div>
      </div>
      <div [formGroup]="form" class="pt-3">
        <kendo-label text="Additional Info"></kendo-label>
        <kendo-textbox
          formControlName="additionalInfo"
          placeholder="Add any other details you'd like us to know"
        ></kendo-textbox>
      </div>
      <div>
        <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
      </div>
      <button
        themeColor="primary"
        size="large"
        type="submit"
        [disabled]="!form.valid"
        kendoButton
      >
        Reactivate
      </button>
    </form>
  </div>
  <div *ngIf="submitted" class="submitted">
    <div class="dialog-title">Your Community Access has been reactivated!</div>
    <p>
      You have recieved an additional 30 days of Community access to the HUNTER
      platform.
    </p>
    <button
      themeColor="primary"
      size="large"
      (click)="returnToResearch()"
      kendoButton
    >
      Return to Research
    </button>
  </div>
</div>
